import { get } from 'lodash'
import { PlanType } from '@labrav/react-components'
import type { ChannelPartnerPrivateOffer } from '../../../../modules/channelPartnerPrivateOffer/reducer'
import type { ReceivedResellerAuthorization } from '../../../../modules/receivedResellerAuthorization/reducer'
import { ContractDurationType, DiscountType } from '../../../../types/flyout'
import type { Dimension } from '../../../../modules/privateOffer/reducer'
import { getMappedMonthKey } from '../../../../utils/contractDuration'
import {
  getShowContractDurationOption,
  getPricesArrayForDimensions,
} from '../../AddEditChannelOfferComponents/helpers'

export { getShowContractDurationOption, getPricesArrayForDimensions }

export const getConditionalPriceLabel = ({
  priceItem,
  resellerAuthorization,
}: {
  priceItem: string
  resellerAuthorization: ReceivedResellerAuthorization
}) => {
  const isResaleAuthCustomDuration =
    resellerAuthorization?.contractDurationType === ContractDurationType.CUSTOM
  const durationPeriod = isResaleAuthCustomDuration
    ? resellerAuthorization?.contractDurationInMonthsForEndCustomer || 0
    : getMappedMonthKey(priceItem)
  const durationLabelText = `${durationPeriod} month${
    durationPeriod > 1 ? 's' : ''
  }`
  const labelConditionalText =
    resellerAuthorization?.productType === PlanType.SAAS_SUBSCRIPTION
      ? 'unit'
      : durationLabelText || ''

  return labelConditionalText
}

export const getDimensionCustomColumnData = ({
  priceItem,
  channelOffer,
  resellerAuthorization,
}: {
  priceItem: string
  channelOffer: ChannelPartnerPrivateOffer
  resellerAuthorization: ReceivedResellerAuthorization
}) => {
  const labelConditionalText = getConditionalPriceLabel({
    priceItem,
    resellerAuthorization,
  })

  const dimColumnsArray = [
    {
      keyName: 'wholesalePrice',
      lable: `Wholesale ${labelConditionalText} price`,
    },
  ]

  channelOffer?.flexiblePaymentTerms
    ? dimColumnsArray.push({
        keyName: 'quantity',
        lable: 'Quantity',
      })
    : dimColumnsArray.push(
        {
          keyName: 'buyerUnitPrice',
          lable: `Buyer ${labelConditionalText} price`,
        },
        {
          keyName: 'margin',
          lable: 'Margin',
        }
      )
  return dimColumnsArray
}

export const getTableDimensions = ({
  priceItem,
  channelOffer,
  resellerAuthorization,
}: {
  priceItem: string
  channelOffer: ChannelPartnerPrivateOffer
  resellerAuthorization: ReceivedResellerAuthorization
}) => {
  const channelOfferDimensions = channelOffer?.dimensions
  const isFlexiblePricingResaleAuth =
    resellerAuthorization?.discountType?.toUpperCase() ===
    DiscountType.FLEXIBLE_PAYMENT_TERMS
  const customContractDuration =
    resellerAuthorization?.contractDurationType === ContractDurationType.CUSTOM

  const resultArray: Dimension[] = []
  channelOfferDimensions?.map(item => {
    const resaleDimension = (resellerAuthorization?.dimensions || [])?.find(
      resaleDimension =>
        resaleDimension?.name === item?.name &&
        !resaleDimension?.isAdditionalUsageAllowed
    )
    const wholesalePrice = get(
      isFlexiblePricingResaleAuth || customContractDuration
        ? resaleDimension
        : resaleDimension?.prices,
      priceItem
    )
    const buyerUnitPrice = get(
      customContractDuration ? item : item.prices,
      priceItem
    )
    channelOffer?.flexiblePaymentTerms
      ? resultArray.push({
          ...item,
          wholesalePrice,
        } as unknown as Dimension)
      : resultArray.push({
          ...item,
          wholesalePrice,
          buyerUnitPrice,
          margin: buyerUnitPrice ? buyerUnitPrice - wholesalePrice : '',
        } as unknown as Dimension)
  })
  return resultArray
}
